export default __webpack_public_path__ + "static/media/delete-icon.46564c34.png";